import { Employees } from 'modules/employees/store/collections/employees'
import type Location from 'modules/locations/store/models/Location'

const locationEmployees = (location: Location, employees: Employees) => {
  return employees.filter({
    location_id: location.attributes.id,
  })
}

export const locationActiveEmployees = (location: Location, employees: Employees) => {
  return locationEmployees(location, employees).filter((employee) => !employee.isTerminated)
}
